import { i18n } from 'platform-lib-app';
/*
 * @Description: 我的
 * @Author:  陈东东
 * @Date: 2022-05-10 09:54:50
 * @LastEditTime: 2023-05-08 22:55:06
 * @LastEditors: chendongdong dongdong.chen@abite.com
 */

export default [
  {
    path: '/my/PersonInfo',
    name: 'PersonInfo',
    component: () => import('./PersonInfo/index.vue'),
    meta: {
      name: i18n.t('cotti_app_h5_903'),
      nologin: true,
    },
  },
  {
    path: '/my/SetUp',
    name: 'setUp',
    component: () => import('./setUp/index.vue'),
    meta: {
      name: i18n.t('cotti_app_h5_196'),
      nologin: true,
    },
  },
  {
    path: '/my/AboutPartnerApp',
    name: 'AboutPartnerApp',
    component: () => import('./aboutPartnerApp/index.vue'),
    meta: {
      name: i18n.t('cotti_app_h5_1475'),
      nologin: true,
    },
  },
  {
    path: '/my/InfoNotice',
    name: 'InfoNotice',
    component: () => import('./infoNotice/index.vue'),
    meta: {
      name: i18n.t('cotti_app_h5_893'),
      nologin: true,
    },
  },
  {
    path: '/my/privacyPolicy',
    name: 'privacyPolicy',
    component: () => import('./privacyPolicy/index.vue'),
    meta: {
      name: i18n.t('cotti_app_h5_914'),
      nologin: true,
    },
  },
  {
    path: '/my/privacy/koConsent',
    name: 'koConsent',
    component: () => import('./privacyPolicy/koConsent.vue'),
    meta: {
      name: i18n.t('cotti_app_h5_914'),
      nologin: true,
    },
  },
  {
    path: '/my/AccountSecurity',
    name: 'AccountSecurity',
    component: () => import('./AccountSecurity/index.vue'),
    meta: {
      name: i18n.t('cotti_app_h5_885'),
      nologin: true,
    },
  },
  {
    path: '/my/AccountVerify',
    name: 'AccountVerify',
    component: () => import('./AccountVerify/index.vue'),
    meta: {
      name: i18n.t('cotti_app_h5_2019'),
    },
  },
  {
    path: '/my/AccountEdit',
    name: 'AccountEdit',
    component: () => import('./AccountEdit/index.vue'),
    meta: {
      name: i18n.t('cotti_app_h5_2020'),
    },
  },
  {
    path: '/my/faceCollect',
    name: 'FaceCollect',
    component: () => import('./faceCollect/index.vue'),
    meta: {
      name: i18n.t('cotti_app_h5_879'),
      nologin: true,
    },
  },

  {
    path: '/my/globalPrivacyPolicy',
    name: 'globalPrivacyPolicy',
    component: () => import('./globalPrivacyPolicy/index.vue'),
    meta: {
      name: i18n.t('cotti_app_h5_914'),
      nologin: true,
    },
  },
  {
    path: '/my/globalPrivacyPolicy/koConsent',
    name: 'globalKoConsent',
    component: () => import('./globalPrivacyPolicy/koConsent.vue'),
    meta: {
      name: i18n.t('cotti_app_h5_914'),
      nologin: true,
    },
  },
  {
    path: '/my/cookie-mangement',
    name: 'cookieManagement',
    component: () => import('./cookie-mangement/index.vue'),
    meta: {
      nologin: true,
    },
  },
  {
    path: '/my/cookie-intro',
    name: 'cookieIntro',
    component: () => import('./cookie-mangement/intro.vue'),
    meta: {
      nologin: true,
    },
  },
  {
    path: '/my/cookie-privacy',
    name: 'cookiePrivacy',
    component: () => import('./cookie-mangement/privacy.vue'),
    meta: {
      nologin: true,
    },
  },
  {
    path: '/my/globalPrivacyPolicyEu',
    name: 'globalPrivacyPolicyEu',
    component: () => import('./globalPrivacyPolicyEU/index.vue'),
    // component: () => import('./globalPrivacyPolicy/index.vue'),
    meta: {
      nologin: true,
    },
  },

];
